import { featuredMatches } from '@/mocks/home';

export default function FeaturedMatches() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="container-custom">
        <div className="flex items-end justify-between mb-10 md:mb-14">
          <div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-2">
              热门赛事
            </h2>
            <p className="text-foreground-500 text-sm md:text-base">精选全球顶级赛事，实时关注精彩对决</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {featuredMatches.map((match) => (
            <div
              key={match.id}
              className="group bg-background-50 rounded-xl border border-background-200/70 p-4 md:p-5 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-center justify-between mb-3">
                <span className="text-xs font-medium text-foreground-500 bg-background-100 px-3 py-1 rounded-full whitespace-nowrap">
                  {match.league}
                </span>
                {match.status === 'live' ? (
                  <span className="flex items-center gap-1 text-xs font-semibold text-primary-500">
                    <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
                    直播中
                  </span>
                ) : (
                  <span className="text-xs text-foreground-400 whitespace-nowrap">
                    {match.time}
                  </span>
                )}
              </div>

              <div className="flex items-center justify-between mb-4">
                <div className="flex flex-col items-center gap-1 flex-1">
                  <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-background-100 flex items-center justify-center text-xs font-heading font-bold text-foreground-600">
                    {match.homeLogo}
                  </div>
                  <span className="text-sm font-medium text-foreground-800 text-center whitespace-nowrap">{match.home}</span>
                </div>
                <div className="px-3 md:px-4">
                  <span className="text-lg md:text-xl font-heading font-bold text-foreground-400">VS</span>
                </div>
                <div className="flex flex-col items-center gap-1 flex-1">
                  <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-background-100 flex items-center justify-center text-xs font-heading font-bold text-foreground-600">
                    {match.awayLogo}
                  </div>
                  <span className="text-sm font-medium text-foreground-800 text-center whitespace-nowrap">{match.away}</span>
                </div>
              </div>

              <div className="flex items-center gap-2 text-xs text-foreground-500 pt-3 border-t border-background-200/70">
                <i className="ri-time-line"></i>
                <span>{match.time}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}